// extracted by mini-css-extract-plugin
export default {"container":"Team_container__brbHL","person":"Team_person__UmW1F","teamLogo":"Team_teamLogo__iycI2"};